import { TForeignTradeByCountriesState } from './types';

export function getCountryAggregated(state: TForeignTradeByCountriesState) {
  return state.countryAggregated;
}
